export default {
  namespaced: true,
  state: {
    templates: [],
    completed: [],
    currentTemplate: undefined,
  },
  mutations: {
    TEMPLATES(state, update) {
      state.templates = update;
    },
    COMPLETED(state, update) {
      state.completed = update;
    },
    CURRENT_TEMPLATE(state, update) {
      state.currentTemplate = update;
    },
  },
};
